import { Select, type SelectProps } from "antd";
import { IconArrowDown } from "@icons/index";
import { useAppSelector } from "@hooks/redux";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { useControllableValue } from "ahooks";

interface SelectLanguageProps extends Omit<SelectProps, "value" | "onChange"> {
  className?: string;
  iconClassName?: string;
  value?: string;
  onChange?: (value: string) => void;
  /** 是否显示 自动选项 */
  prefixAutoOption?: boolean;
  /** 前置选项，会显示在前面 */
  prefixOptions?: SelectProps["options"];
}

/**
 * Video Language Select Component
 * 基于 Redux 中 configReducer.videoLanguage 渲染选项
 */
export function SelectLanguage(props: SelectLanguageProps) {
  const { className, iconClassName, prefixOptions, prefixAutoOption, ...restProps } = props;
  const [language, setLanguage] = useControllableValue<string | undefined>(props);
  const { t } = useTranslation();
  const { videoLanguage } = useAppSelector((state) => state.configReducer);
  const options = useMemo(() => {
    const presetOptions = videoLanguage.map((l) => ({ label: t(l.label), value: l.value }));
    const autoOption = prefixAutoOption ? [{ label: t("Auto"), value: "auto" }] : [];
    return [...(prefixOptions || []), ...autoOption, ...presetOptions];
  }, [videoLanguage, t, prefixOptions, prefixAutoOption]);

  return (
    <Select
      {...restProps}
      options={options}
      suffixIcon={<IconArrowDown className={twMerge("w-[16px] h-[16px] text-kds-fg-subtle", iconClassName)} />}
      value={language}
      onChange={setLanguage}
      className={twMerge("w-full", className)}
    />
  );
}
